/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Missmatchdefect1Inputs */



/**
* | output |
* | --- |
* | "Mismatch defect" |
*
* @param {Br_History_Key_Missmatchdefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_missmatchdefect1 = /** @type {((inputs?: Br_History_Key_Missmatchdefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Missmatchdefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Mismatch defect")
	return /** @type {LocalizedString} */ ("Défaut de discordance")
});
export { br_history_key_missmatchdefect1 as "br_history_key_missmatchDefect" }